export enum ValueEditorType {
    Select = "select",
    MultiSelect = "multiselect",
}

export enum CustomComponentType {
    DependantSelector = "dependantSelector",
    Selector = "selector",
}

export enum OperatorType {
    AND = "and",
    OR = "or",
    IN = "in",
}

export const COMBINATORS = [{ name: OperatorType.AND, label: OperatorType.AND }];
